export const claimHeaders = {
  ClaimNo: 'Claim No',
  ClaimDt: 'Claim Date',
  Employee: 'Employee',
  Curr: 'Currency',
  Amount: 'Amount',
  ClaimStatus: 'Status',
  'Settlement Date': 'Settlement Date',
};

export const EXPENSE_CODETYPES = {
  EXPENSE_GRP: 'EXPENSE_GRP',
  EXPENSE_CATEGORY: 'EXPENSE_CATEGORY',
  EXPENSE_TYPE: 'EXPENSE_TYPE',
};
